import axios from "axios";

export const getBillPrintSettings = () => {
  return axios.get("/api/1.0/bill-print-settings");
};

export const updateBillPrintSettings = (body) => {
  return axios.put("/api/1.0/bill-print-settings", body);
};
